"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStockTiles = exports.getSearchTiles = exports.getTiles = exports.getStockDetailHeight = exports.getDetailHeight = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _reselect = require("reselect");

var _Constants = require("FileManagerCore/Constants");

var _image = require("FileManagerCore/utils/image");

var _Constants2 = require("FileManagerLib/Constants");

var _Folders = require("FileManagerLib/selectors/Folders");

var _Files = require("FileManagerLib/selectors/Files");

var shutterstockSelectors = _interopRequireWildcard(require("FileManagerCore/selectors/Shutterstock"));

var COLUMN_WIDTH = 120;
var GUTTER = 10;
var FOLDER_HEIGHT = 54;
var FILE_HEIGHT = FOLDER_HEIGHT;
var DEFAULT_VIDEO_HEIGHT = 70;
var DETAIL_HEIGHT_WITHOUT_IMAGE = 248;
var FOLDER_LIST_BOTTOM_MARGIN = 24;
var WIDTH = COLUMN_WIDTH * 3 + GUTTER * 2;

var getType = function getType(state, props) {
  return props.type;
};

var getPanel = function getPanel(state) {
  return state.panel;
};

var isFileDrawerType = function isFileDrawerType(drawerType) {
  return drawerType === _Constants2.DrawerTypes.FILE || drawerType === _Constants2.DrawerTypes.DOCUMENT;
};

function getThumbnailCell(column, nextOffsets, file) {
  var x = column * (COLUMN_WIDTH + GUTTER);
  var y = nextOffsets.get(column);
  var width = COLUMN_WIDTH;
  var height = FOLDER_HEIGHT;

  if (file.get('type') === _Constants.FileTypes.MOVIE && !file.hasIn(['meta', 'thumbs', 'medium', 'friendly_url'])) {
    height = DEFAULT_VIDEO_HEIGHT;
  } else if (file.get('height') && file.get('width')) {
    var ratio = file.get('height') / file.get('width');
    height = width * ratio;
  }

  return {
    cell: _immutable.default.Map({
      type: _Constants2.CellTypes.THUMBNAIL,
      image: file,
      x: x,
      y: y,
      width: width,
      height: height
    }),
    nextOffset: y + height + GUTTER
  };
}

function getFileRow(_ref) {
  var nextOffsets = _ref.nextOffsets,
      file = _ref.file,
      isLast = _ref.isLast;
  var y = nextOffsets.get(0);
  var height = FILE_HEIGHT;
  return {
    cell: _immutable.default.Map({
      type: _Constants2.CellTypes.FILE,
      file: file,
      x: 0,
      y: y,
      width: WIDTH,
      height: height,
      isLast: isLast
    }),
    nextOffset: y + FILE_HEIGHT
  };
}

function layoutStockTiles(type, stockImages, panel, detailHeight) {
  var nextOffsets = new _immutable.default.OrderedMap([[0, 0], [1, 0], [2, 0]]);
  var cells = [];

  var getColumn = function getColumn() {
    var min = nextOffsets.min();
    return nextOffsets.findKey(function (val) {
      return val === min;
    });
  };

  stockImages.forEach(function (image, index) {
    var column = getColumn();

    if (isFileDrawerType(type)) {
      var _getFileRow = getFileRow({
        column: column,
        nextOffsets: nextOffsets,
        image: image,
        isLast: index === stockImages.count() - 1
      }),
          cell = _getFileRow.cell,
          nextOffset = _getFileRow.nextOffset;

      cells.push(cell);
      nextOffsets = nextOffsets.merge([[0, nextOffset], [1, nextOffset], [2, nextOffset]]);
    } else {
      var _getThumbnailCell = getThumbnailCell(column, nextOffsets, image),
          _cell = _getThumbnailCell.cell,
          _nextOffset = _getThumbnailCell.nextOffset;

      cells.push(_cell);
      nextOffsets = nextOffsets.set(column, _nextOffset);
    }

    var selectedStockFile = panel.getIn(['present', 'selectedStockFile']);

    var isSelected = function isSelected(stockImage) {
      return selectedStockFile && selectedStockFile.get('id') === stockImage.get('id');
    };

    var getSelectedFileCell = function getSelectedFileCell() {
      var offsetY = nextOffsets.get(column);

      if (isFileDrawerType(type)) {
        offsetY = offsetY + GUTTER;
      }

      var arrowX = column * (COLUMN_WIDTH + GUTTER) + COLUMN_WIDTH * 0.5;
      var height;

      if (detailHeight) {
        height = detailHeight;
      } else {
        var dimensions = (0, _image.scaleToFit)(image, WIDTH);
        height = dimensions.height + DETAIL_HEIGHT_WITHOUT_IMAGE;
      }

      return _immutable.default.Map({
        type: _Constants2.CellTypes.FILE_DETAIL,
        x: 0,
        y: offsetY,
        width: WIDTH,
        height: height,
        detailHeight: detailHeight,
        arrowX: arrowX,
        image: image
      });
    };

    if (isSelected(image)) {
      var selectedFileCell = getSelectedFileCell({
        drawerType: type
      });
      cells.push(selectedFileCell);
      var yOffset = selectedFileCell.get('y') + selectedFileCell.get('height') + GUTTER;
      nextOffsets = nextOffsets.merge([[0, yOffset], [1, yOffset], [2, yOffset]]);
    }
  });
  return new _immutable.default.List(cells);
}

function layoutTiles(type, files, folders, panel, detailHeight) {
  var uploadingFiles = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new _immutable.default.List();
  var nextOffsets = new _immutable.default.OrderedMap([[0, 0], [1, 0], [2, 0]]);
  var cells = [];

  var getColumn = function getColumn() {
    var min = nextOffsets.min();
    return nextOffsets.findKey(function (val) {
      return val === min;
    });
  };

  var getSelectedFileCell = function getSelectedFileCell(_ref2) {
    var drawerType = _ref2.drawerType,
        file = _ref2.file,
        column = _ref2.column;
    var offsetY = nextOffsets.get(column);

    if (isFileDrawerType(drawerType)) {
      offsetY = offsetY + GUTTER;
    }

    var arrowX = column * (COLUMN_WIDTH + GUTTER) + COLUMN_WIDTH * 0.5;
    var height;

    if (detailHeight) {
      height = detailHeight;
    } else {
      var dimensions = (0, _image.scaleToFit)(file, WIDTH);
      height = dimensions.height + DETAIL_HEIGHT_WITHOUT_IMAGE;
    }

    return _immutable.default.Map({
      type: _Constants2.CellTypes.FILE_DETAIL,
      x: 0,
      y: offsetY,
      width: WIDTH,
      height: height,
      detailHeight: detailHeight,
      arrowX: arrowX,
      file: file
    });
  };

  var activePanel = panel.getIn(['present', 'activePanel']);
  var selectedFile = panel.getIn(['present', 'selectedFile']);
  var actualFolders = activePanel === _Constants2.Panels.BROWSE ? new _immutable.default.List() : folders;

  var isSelected = function isSelected(file) {
    return selectedFile && selectedFile.get('id') === file.get('id');
  };

  var allFiles = uploadingFiles.concat(files);
  actualFolders.forEach(function (folder, index) {
    var y = nextOffsets.get(0);
    var height = FOLDER_HEIGHT;
    var isLast = index === actualFolders.count() - 1;
    var nextOffset = y + FOLDER_HEIGHT;

    if (!isFileDrawerType(type) && isLast) {
      nextOffset = nextOffset + FOLDER_LIST_BOTTOM_MARGIN;
    }

    cells.push(_immutable.default.Map({
      type: _Constants2.CellTypes.FOLDER,
      x: 0,
      y: y,
      width: WIDTH,
      isLast: !isFileDrawerType(type) || allFiles.count() === 0 ? isLast : false,
      height: height,
      folder: folder
    }));
    nextOffsets = nextOffsets.merge([[0, nextOffset], [1, nextOffset], [2, nextOffset]]);
  });
  allFiles.forEach(function (file, index) {
    var column = getColumn();

    if (isFileDrawerType(type)) {
      var _getFileRow2 = getFileRow({
        column: column,
        nextOffsets: nextOffsets,
        file: file,
        isLast: index === allFiles.count() - 1
      }),
          cell = _getFileRow2.cell,
          nextOffset = _getFileRow2.nextOffset;

      cells.push(cell);
      nextOffsets = nextOffsets.merge([[0, nextOffset], [1, nextOffset], [2, nextOffset]]);
    } else {
      var _getThumbnailCell2 = getThumbnailCell(column, nextOffsets, file),
          _cell2 = _getThumbnailCell2.cell,
          _nextOffset2 = _getThumbnailCell2.nextOffset;

      cells.push(_cell2);
      nextOffsets = nextOffsets.set(column, _nextOffset2);
    }

    if (isSelected(file)) {
      var selectedFileCell = getSelectedFileCell({
        drawerType: type,
        file: file,
        column: column
      });
      cells.push(selectedFileCell);
      var yOffset = selectedFileCell.get('y') + selectedFileCell.get('height') + GUTTER;
      nextOffsets = nextOffsets.merge([[0, yOffset], [1, yOffset], [2, yOffset]]);
    }
  });
  return new _immutable.default.List(cells);
}

var getDetailHeights = function getDetailHeights(state) {
  return state.detailHeights;
};

var getDetailHeight = (0, _reselect.createSelector)([getPanel, getDetailHeights], function (panel, heights) {
  var selectedFile = panel.getIn(['present', 'selectedFile']);

  if (!selectedFile || !heights.has(selectedFile.get('id'))) {
    return null;
  }

  return heights.get(selectedFile.get('id'));
});
exports.getDetailHeight = getDetailHeight;
var getStockDetailHeight = (0, _reselect.createSelector)([getPanel, getDetailHeights], function (panel, heights) {
  var selectedFile = panel.getIn(['present', 'selectedStockFile']);

  if (!selectedFile || !heights.has(selectedFile.get('id'))) {
    return null;
  }

  return heights.get(selectedFile.get('id'));
});
exports.getStockDetailHeight = getStockDetailHeight;
var getTiles = (0, _reselect.createSelector)([getType, _Files.getFilesWithSupportInfo, _Folders.getChildFolders, getPanel, getDetailHeight, _Files.getUploadingFilesWithSupportInfo], layoutTiles);
exports.getTiles = getTiles;
var getSearchTiles = (0, _reselect.createSelector)([getType, _Files.getFilesWithSupportInfo, _Folders.getFilteredFolders, getPanel, getDetailHeight], layoutTiles);
exports.getSearchTiles = getSearchTiles;
var getStockTiles = (0, _reselect.createSelector)([getType, shutterstockSelectors.getResults, getPanel, getStockDetailHeight], layoutStockTiles);
exports.getStockTiles = getStockTiles;